module.exports = __webpack_public_path__ + "static/media/la.b1c29935.svg";